import React from "react";
import "./styles.scss";
import TableRow from "@mui/material/TableRow";
import TableItem from "../tableItem";

function TableItemRow(props) {
  const {
    items,
    id,
    onClick,
    className = "",
    stickyFirstColumn = false,
    stickyLastColumn = false,
  } = props;

  const tableItem = (item, index) => {
    const isFirstColumn = index === 0 && stickyFirstColumn;
    const isLastColumn = index === items.length - 1 && stickyLastColumn;
    const stickyClass = isFirstColumn
      ? "sticky-first-column"
      : isLastColumn
        ? "sticky-last-column"
        : "";

    return (
      <TableItem key={Math.random()} body={item} className={stickyClass} />
    );
  };

  return (
    <TableRow
      id={id}
      key={id}
      className={className}
      hover={!!onClick}
      onClick={onClick}
      component={"tr"}
    >
      {items.map(tableItem)}
    </TableRow>
  );
}

export default TableItemRow;
